// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductDetailedPage_container__3tC_g","emptydiv":"ProductDetailedPage_emptydiv__3jIR6"};